// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
	font-family: MuseoSans-500;
	font-size: 18px;
	color: #404141;
	margin-top: 10px;
	margin-bottom: 26px;
}

.subtitle-container {
  font-family: MuseoSans-500;
  margin-bottom: 20px;
}

.subtitle {
  font-size: 14px;
  color: #404141;
}

.platform {
  font-size: 16px;
}

.advanced {
	margin-top: 0px;
	margin-bottom: 20px;
}

.form-group > label {
	font-family: MuseoSans-300;
	font-size: 13px;
	color: #404141;
}

hr {
  margin: 10px -18px;
}

span.info > img {
	margin-top: 4px;
}

.report-and-logs button {
	width: 200px;
	margin-right: 30px;
}

.report-and-logs p {
	margin-bottom: 28px;
	font-family: MuseoSans-300;
	font-size: 12px;
	color: #404141;
}

.auto-update-schedule input[type="checkbox"] {
	opacity: 0;
	width: 106px;
	cursor: pointer;
}

.auto-update-schedule input[type="checkbox"] + label {
	font-family: MuseoSans-300;
	font-size: 12px;
	color: #404141;
	margin: 0;
	margin-left: -106px;
	clear: none;
	padding-left: 34px;
	background: url('Unchecked.svg') left center no-repeat;
}

.auto-update-schedule input[type="checkbox"].checked + label {
	background: url('Checked.svg') left center no-repeat;
}

.auto-update-schedule .title {
	margin-bottom: 22px;
}

.auto-update-schedule .btn-group {
	margin-top: 28px;
}

.auto-update-schedule .grey-out {
	opacity: 0.5;
	pointer-events: none;
}

label.btn-secondary {
	color: #212529;
	background-color: #F5F5F6;
	font-family: MuseoSans-300;
	font-size: 12px;
	margin-bottom: 0px;
	height: 30px;
	min-width: 90px;
	text-align: center;
	line-height: 1;
	border: none;
	border-radius: 0px;
}

label.btn-secondary.active, label.btn-secondary:active {
	border: 1px solid #00A1E0 !important;
	background-color: transparent !important;
	color: #00A1E0 !important;
}

.btn-secondary:disabled {
	color: #15325F !important;
}

select {
	height: 30px !important;
	padding-top: 6px;
	padding-bottom: 6px;
	padding-right: 28px;
  -o-appearance: none;
  appearance: none;
  border-radius: 0px;
  -moz-border-radius: 0px;
  -webkit-border-radius: 0px;
  border: 1px solid #BFBFC0;
  font-family: MuseoSans-300;
	font-size: 12px;
	color: #404141;
}

select::-ms-expand {
  display: none;
}

select + span {
  float: right;
  margin-top: -27px;
  margin-right: 5px;
  pointer-events: none;
  background-color: #fff;
  padding-right: 5px;
  height: 14px;
}

select + span img {
	width: 14px;
	height: 14px;
	vertical-align: -3px;
}

.auto-update-time {
	margin-top: 28px;
}

.auto-update-time label {
	font-family: MuseoSans-300;
	font-size: 13px;
	color: #404141;
}

.trace-calls-actions {
	padding-top: 30px;
	padding-left: 0px;
}

.trace-calls button {
	min-width: 100px;
}

.trace-calls .btn-primary {
	margin-right: 15px;
	margin-left: 3px;
}

.extra-margin-bottom {
	margin-bottom: 10px;
}

.system-options .row {
	margin-bottom: 28px;
}

.system-options .row:last-of-type {
	margin-bottom: 18px;
}

.system-options span {
	font-family: MuseoSans-300;
	font-size: 12px;
	color: #404141;
}

.system-options p {
	font-family: MuseoSans-300;
	font-size: 12px;
	color: #404141;
	margin-bottom: 0px;
	line-height: 1.25;
}

.system-options button {
	width: 200px;
	margin-right: 30px;
}

.system-options .row div:last-of-type {
	padding-left: 22px;
}

.system-version p {
	font-family: MuseoSans-500;
	font-size: 15px;
	line-height: 1;
	margin-bottom: 18px;
}

.system-version .col-11 {
	padding-left: 0px;
}

.system-version p span {
	font-family: MuseoSans-300;
	font-size: 12px;
	vertical-align: middle;
}

.system-version p span.version {
	font-family: MuseoSans-500;
	font-size: 12px;
}

.system-version p span.detail {
	font-family: MuseoSans-500;
	font-size: 12px;
	margin-left: 12px;
}

.system-version button {
	text-decoration: none;
}

.system-version button:hover {
	text-decoration: underline;
}
.system-version .btn-link {
	font-family: MuseoSans-500;
	font-size: 12px;
	color: #00a1e0;
	padding-top: 0px;
	padding-bottom: 0px;
}

.system-version .btn-link img {
	margin-right: 9px;
}

.system-version .btn-link span {
	vertical-align: 1px;
}

button + label {
	font-family: MuseoSans-300;
	font-size: 12px;
	color: #404141;
	margin: 5px 0px 0px 30px;
	vertical-align: top;
}

.actions {
	position: relative;
	bottom: 20px;
	right: 10px;
	margin: 36px -10px -10px 0px;
}

.actions button {
	min-width: 100px;
}

.btn-primary {
	margin-left: 10px;
}

.text-danger {
	font-family: MuseoSans-500;
	font-size: 11px;
	color: #ED1C24;
	margin-top: -14px;
}

.lbl {
	position: relative;
	display: block;
	height: 12px;
	width: 48px;
	background: #e6e7e8;
	border-radius: 100px;
	cursor: pointer;
	transition: all 0.3s ease;
}

.lbl:after {
	position: absolute;
	left: 0px;
	top: 0px;
	display: block;
	width: 12px;
	height: 12px;
	border-radius: 100px;
	background: #cccdce;
	content: '';
	transition: all 0.3s ease;
}

.lbl:active:after {
	transform: scale(1.15, 0.85);
}

.cbx:checked ~ label {
	background: #99d9f3;
}

.cbx:checked ~ label:after {
	left: 28px;
	width: 20px;
	height: 20px;
	top: -4px;
	background: #00a1e0;
}

.cbx:disabled ~ label {
	background: #f5f5f6;
	pointer-events: none;
}

.cbx:disabled ~ label:after {
	background: #e6e7e8;
}

.press {
	margin-top: 5px;
}

.hidden {
	display: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/advanced-form/advanced-form.component.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,SAAS;CACT,mBAAmB;CACnB,WAAW;CACX,kBAAkB;CAClB,sDAA6E;AAC9E;;AAEA;CACC,oDAA2E;AAC5E;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,0BAA0B;CAC1B,eAAe;CACf,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,oCAAoC;CACpC,wCAAwC;CACxC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;EAGlB,mBAAmB;EAEnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;CAC3B,eAAe;CACf,cAAc;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,0BAA0B;AAC3B;AACA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,wBAAwB;CACxB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,4BAA4B;AAC7B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,oBAAoB;CACpB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,cAAc;CACd,WAAW;CACX,YAAY;CACZ,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,YAAY;CACZ,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;AACd","sourcesContent":[".title {\n\tfont-family: MuseoSans-500;\n\tfont-size: 18px;\n\tcolor: #404141;\n\tmargin-top: 10px;\n\tmargin-bottom: 26px;\n}\n\n.subtitle-container {\n  font-family: MuseoSans-500;\n  margin-bottom: 20px;\n}\n\n.subtitle {\n  font-size: 14px;\n  color: #404141;\n}\n\n.platform {\n  font-size: 16px;\n}\n\n.advanced {\n\tmargin-top: 0px;\n\tmargin-bottom: 20px;\n}\n\n.form-group > label {\n\tfont-family: MuseoSans-300;\n\tfont-size: 13px;\n\tcolor: #404141;\n}\n\nhr {\n  margin: 10px -18px;\n}\n\nspan.info > img {\n\tmargin-top: 4px;\n}\n\n.report-and-logs button {\n\twidth: 200px;\n\tmargin-right: 30px;\n}\n\n.report-and-logs p {\n\tmargin-bottom: 28px;\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #404141;\n}\n\n.auto-update-schedule input[type=\"checkbox\"] {\n\topacity: 0;\n\twidth: 106px;\n\tcursor: pointer;\n}\n\n.auto-update-schedule input[type=\"checkbox\"] + label {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #404141;\n\tmargin: 0;\n\tmargin-left: -106px;\n\tclear: none;\n\tpadding-left: 34px;\n\tbackground: url('../../../assets/images/Unchecked.svg') left center no-repeat;\n}\n\n.auto-update-schedule input[type=\"checkbox\"].checked + label {\n\tbackground: url('../../../assets/images/Checked.svg') left center no-repeat;\n}\n\n.auto-update-schedule .title {\n\tmargin-bottom: 22px;\n}\n\n.auto-update-schedule .btn-group {\n\tmargin-top: 28px;\n}\n\n.auto-update-schedule .grey-out {\n\topacity: 0.5;\n\tpointer-events: none;\n}\n\nlabel.btn-secondary {\n\tcolor: #212529;\n\tbackground-color: #F5F5F6;\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tmargin-bottom: 0px;\n\theight: 30px;\n\tmin-width: 90px;\n\ttext-align: center;\n\tline-height: 1;\n\tborder: none;\n\tborder-radius: 0px;\n}\n\nlabel.btn-secondary.active, label.btn-secondary:active {\n\tborder: 1px solid #00A1E0 !important;\n\tbackground-color: transparent !important;\n\tcolor: #00A1E0 !important;\n}\n\n.btn-secondary:disabled {\n\tcolor: #15325F !important;\n}\n\nselect {\n\theight: 30px !important;\n\tpadding-top: 6px;\n\tpadding-bottom: 6px;\n\tpadding-right: 28px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -o-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n  border-radius: 0px;\n  -moz-border-radius: 0px;\n  -webkit-border-radius: 0px;\n  border: 1px solid #BFBFC0;\n  font-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #404141;\n}\n\nselect::-ms-expand {\n  display: none;\n}\n\nselect + span {\n  float: right;\n  margin-top: -27px;\n  margin-right: 5px;\n  pointer-events: none;\n  background-color: #fff;\n  padding-right: 5px;\n  height: 14px;\n}\n\nselect + span img {\n\twidth: 14px;\n\theight: 14px;\n\tvertical-align: -3px;\n}\n\n.auto-update-time {\n\tmargin-top: 28px;\n}\n\n.auto-update-time label {\n\tfont-family: MuseoSans-300;\n\tfont-size: 13px;\n\tcolor: #404141;\n}\n\n.trace-calls-actions {\n\tpadding-top: 30px;\n\tpadding-left: 0px;\n}\n\n.trace-calls button {\n\tmin-width: 100px;\n}\n\n.trace-calls .btn-primary {\n\tmargin-right: 15px;\n\tmargin-left: 3px;\n}\n\n.extra-margin-bottom {\n\tmargin-bottom: 10px;\n}\n\n.system-options .row {\n\tmargin-bottom: 28px;\n}\n\n.system-options .row:last-of-type {\n\tmargin-bottom: 18px;\n}\n\n.system-options span {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #404141;\n}\n\n.system-options p {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #404141;\n\tmargin-bottom: 0px;\n\tline-height: 1.25;\n}\n\n.system-options button {\n\twidth: 200px;\n\tmargin-right: 30px;\n}\n\n.system-options .row div:last-of-type {\n\tpadding-left: 22px;\n}\n\n.system-version p {\n\tfont-family: MuseoSans-500;\n\tfont-size: 15px;\n\tline-height: 1;\n\tmargin-bottom: 18px;\n}\n\n.system-version .col-11 {\n\tpadding-left: 0px;\n}\n\n.system-version p span {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tvertical-align: middle;\n}\n\n.system-version p span.version {\n\tfont-family: MuseoSans-500;\n\tfont-size: 12px;\n}\n\n.system-version p span.detail {\n\tfont-family: MuseoSans-500;\n\tfont-size: 12px;\n\tmargin-left: 12px;\n}\n\n.system-version button {\n\ttext-decoration: none;\n}\n\n.system-version button:hover {\n\ttext-decoration: underline;\n}\n.system-version .btn-link {\n\tfont-family: MuseoSans-500;\n\tfont-size: 12px;\n\tcolor: #00a1e0;\n\tpadding-top: 0px;\n\tpadding-bottom: 0px;\n}\n\n.system-version .btn-link img {\n\tmargin-right: 9px;\n}\n\n.system-version .btn-link span {\n\tvertical-align: 1px;\n}\n\nbutton + label {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #404141;\n\tmargin: 5px 0px 0px 30px;\n\tvertical-align: top;\n}\n\n.actions {\n\tposition: relative;\n\tbottom: 20px;\n\tright: 10px;\n\tmargin: 36px -10px -10px 0px;\n}\n\n.actions button {\n\tmin-width: 100px;\n}\n\n.btn-primary {\n\tmargin-left: 10px;\n}\n\n.text-danger {\n\tfont-family: MuseoSans-500;\n\tfont-size: 11px;\n\tcolor: #ED1C24;\n\tmargin-top: -14px;\n}\n\n.lbl {\n\tposition: relative;\n\tdisplay: block;\n\theight: 12px;\n\twidth: 48px;\n\tbackground: #e6e7e8;\n\tborder-radius: 100px;\n\tcursor: pointer;\n\ttransition: all 0.3s ease;\n}\n\n.lbl:after {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tdisplay: block;\n\twidth: 12px;\n\theight: 12px;\n\tborder-radius: 100px;\n\tbackground: #cccdce;\n\tcontent: '';\n\ttransition: all 0.3s ease;\n}\n\n.lbl:active:after {\n\ttransform: scale(1.15, 0.85);\n}\n\n.cbx:checked ~ label {\n\tbackground: #99d9f3;\n}\n\n.cbx:checked ~ label:after {\n\tleft: 28px;\n\twidth: 20px;\n\theight: 20px;\n\ttop: -4px;\n\tbackground: #00a1e0;\n}\n\n.cbx:disabled ~ label {\n\tbackground: #f5f5f6;\n\tpointer-events: none;\n}\n\n.cbx:disabled ~ label:after {\n\tbackground: #e6e7e8;\n}\n\n.press {\n\tmargin-top: 5px;\n}\n\n.hidden {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
